import { Box, Card, CardContent, Typography } from "@mui/material"
import { icons } from "../../utils"
import useStyles from "./style"
import { lists } from "../../utils"
import tickets from "../../services/tickets"
import { useState, useEffect } from "react"
import Loader from "../loader"
import { pqrDate } from "./useDate"

const PqrCard = ({ ticketId }) => {
  const classes = useStyles()

  const [ticketsData, setTicketsData] = useState({})
  const [isLoading, setIsLoading] = useState(true)

  const getTickets = async (id) => {
    setIsLoading(true)
    try {
      const response = await tickets.getTicket(id)
      setTicketsData(response?.data)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  console.log(ticketsData)

  useEffect(() => {
    getTickets(ticketId)
  }, [ticketId])

  return isLoading ? (
    <Loader size={34} />
  ) : ticketsData ? (
    ticketsData?.history?.map((item) => (
      <Card
        key={item.ticket_id}
        sx={{ display: "flex" }}
        className={classes.card}
      >
        <Box
          className={item.status !== 3 ? classes.bgUnCheck : classes.bgCheck}
        >
          <Box className={classes.typeContainer}>
            <Typography className={classes.type}>
              {ticketsData?.ticket_type?.toUpperCase()}
            </Typography>
          </Box>
          <Box
            className={
              item.status !== 3
                ? classes.responseContainerUnCheck
                : classes.responseContainerCheck
            }
          >
            <Typography variant="subtitle1" className={classes.response}>
              {lists.pqrCard.status[item?.status]}
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "row" }}
          className={classes.text}
        >
          <CardContent className={classes.info}>
            <Typography className={classes.titles}>
              {lists.pqrCard.ticket_id}
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitles}>
              {item?.ticket_id}
            </Typography>
          </CardContent>
          <CardContent className={classes.info}>
            <Typography className={classes.titles}>
              {lists.pqrCard.ticket_date}
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitles}>
              {pqrDate(item?.created_at)}
            </Typography>
          </CardContent>
          <CardContent className={classes.info}>
            <Typography className={classes.titles}>
              {lists.pqrCard.ticket_response}
            </Typography>
            <Typography variant="subtitle1" className={classes.subtitles}>
              {item.attended_by ? pqrDate(item?.updated_at) : "-"}
            </Typography>
          </CardContent>
          <CardContent className={classes.info}>
            {item.status !== 3 ? icons("update") : icons("check")}
          </CardContent>
        </Box>
      </Card>
    ))
  ) : (
    <Typography variant="h4" className={classes.ticketNotFound}>
      Número de radicado no encontrado.
    </Typography>
  )
}

export default PqrCard
